export default Object.freeze({
	DIRECT_DEBIT: 'DIRECT_DEBIT',
	BPAY: 'BPAY',
	DEBIT_CREDIT_CARD: 'DEBIT_CREDIT_CARD',
});
